import mergeConfig from 'coact/config/mergeConfig'

import retailOrders from './retailOrders.js'
import retailOrderItems from './retailOrderItems.js'

const config = {
  models: {
    retailOrders,
    retailOrderItems,
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
